import React, {useState} from 'react';
import { getCaseLabel, getCitationLabel } from "./lookupFunctions";
import { getCurrency } from "../global/utils";
import { dateIso2Us } from '../global/dateUtils';
import { useStyles    } from "../styles/styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'

const PartyListItem = (props) => {
    const partyRec = props.partyRec;
    const court = props.court;
    const selectParty = props.selectParty;
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [open, setOpen] = useState(false);

    // Expand/Hide is a disclosure control, so it carries aria-expanded (4.1.2).
    // No aria-controls: the balances render as one Collapse per balance with
    // unmountOnExit, so there is no single, always-present container to point at.
    const buttonLabel = () => {
        return open ? 'Hide' : 'Expand';
    }

    return (
        <ListItem alignItems='flex-start' sx={classes.listPadding}>
            <ListItemText
                sx={classes.listText}
                primary={
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            alignItems: "top",
                            width: '100%'
                        }}>
                        {!smallScreen ? (
                            <>
                                <Grid
                                    size={{
                                        xs: 3,
                                        lg: 2
                                    }}>
                                    <Tooltip title='Pay one or more balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            color='success'
                                            onClick={() => selectParty(partyRec)}
                                            sx={classes.tinyButton}
                                        >
                                            Select
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 5,
                                        lg: 5
                                    }}>
                                    {
                                        partyRec.party.partyName ? partyRec.party.partyName :
                                            `${partyRec.party.lastName}, ${partyRec.party.firstName}`
                                    }
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 4,
                                        lg: 3
                                    }}>
                                    {partyRec.party.dob && !court.hidePartyDob ? dateIso2Us(partyRec.party.dob) : ''}
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        lg: 2
                                    }}>
                                    <Box component='span' sx={{display: 'flex', flexDirection: 'row-reverse'}}>
                                        <Tooltip title='Show/hide the balances for this party' TransitionComponent={Zoom} arrow>
                                            <Button
                                                variant='contained'
                                                onClick={() => setOpen(!open)}
                                                sx={classes.tinyButton}
                                                aria-expanded={open}
                                            >
                                                {buttonLabel()}
                                            </Button>
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid size={12}>
                                    {
                                        partyRec.party.partyName ? partyRec.party.partyName :
                                            `${partyRec.party.lastName}, ${partyRec.party.firstName}`
                                    }
                                </Grid>
                                <Grid size={12}>
                                    {partyRec.party.dob && !court.hidePartyDob ? dateIso2Us(partyRec.party.dob) : ''}
                                </Grid>
                                <Grid sx={{display: 'flex', justifyContent: 'flex-start'}} size={6}>
                                    <Tooltip title='Pay one or more balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            color='success'
                                            onClick={() => selectParty(partyRec)}
                                            sx={classes.tinyButton}
                                        >
                                            Select
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                <Grid sx={{display: 'flex', justifyContent: 'flex-end'}} size={6}>
                                    <Tooltip title='Show/hide the balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            onClick={() => setOpen(!open)}
                                            sx={classes.tinyButton}
                                            aria-expanded={open}
                                        >
                                            {buttonLabel()}
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </>
                        )}
                    </Grid>
                }
                primaryTypographyProps={{
                    component: 'span',
                    variant: 'subtitle1',
                    sx: classes.inline,
                    color: 'textPrimary'
                }}
                secondary={
                    <>
                        {partyRec.balances.map((balance) => {
                            return (
                                <Collapse in={open} timeout='auto' unmountOnExit>
                                    <Grid
                                        container
                                        spacing={2}
                                        style={{width: '100%'}}
                                        sx={{
                                            alignItems: "top"
                                        }}
                                    >
                                        {/* Stands in for the Select button column above, so this row's
                                            case number lines up under the party name and the citation
                                            under the DOB (2/5/3 in both rows). Written as
                                            <Grid lg={2}> without `item`, so MUI ignored lg and the
                                            spacer collapsed to the width of the &nbsp;, pulling the
                                            whole row two columns left. */}
                                        { !smallScreen &&
                                            <Grid size={{lg: 2}}>&nbsp;</Grid>
                                        }
                                        <Grid
                                            size={{
                                                xs: 6,
                                                lg: 5
                                            }}>
                                            {`${getCaseLabel(court)} ${balance.caseNumber}`}
                                        </Grid>
                                        { balance.citationNumber ?
                                            <Grid
                                                size={{
                                                    xs: 5,
                                                    lg: 3
                                                }}>
                                                {`${getCitationLabel(court)} ${balance.citationNumber}`}
                                            </Grid>:
                                            <Grid
                                                size={{
                                                    xs: 5,
                                                    lg: 3
                                                }}>
                                                &nbsp;
                                            </Grid>
                                        }
                                        <Grid
                                            size={{
                                                xs: 0,
                                                lg: 2
                                            }}>&nbsp;</Grid>
                                        <Grid
                                            size={{
                                                xs: 0,
                                                lg: 2
                                            }}>&nbsp;</Grid>
                                        <Grid
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 12,
                                                lg: 10
                                            }}>
                                            {balance.description}
                                        </Grid>
                                        { !smallScreen &&
                                            <Grid
                                                size={{
                                                    lg: 2
                                                }}>&nbsp;</Grid>
                                        }
                                        <Grid
                                            sx={{marginBottom: '.5rem'}}
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 6,
                                                lg: 5
                                            }}>
                                            {!balance.ineligibleForPayment ? `Amount: ${getCurrency(balance.courtAmount)}`: ' '}
                                        </Grid>
                                        <Grid
                                            sx={{marginBottom: '.5rem'}}
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 5,
                                                lg: 3
                                            }}>
                                            {`Status: ${balance.ineligibleForPayment ? 'Not payable' : (balance.disposed ? 'Assessed' : 'Pending')}`}
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            );
                        })}
                    </>
                }
                secondaryTypographyProps={{
                    component: 'span',
                    variant: 'body2',
                    sx: classes.inline,
                    color: 'textPrimary'
                }}
            />
        </ListItem>
    );
}

export default PartyListItem;
